import {Component, OnInit} from '@angular/core';

import {ToastrService} from 'ngx-toastr';

import {ApiService} from '../../../services/api.service';
import {MockDataService} from '../../../services/mock-data.service';
import {UserService} from '../../../services/user.service';
import {ElectricityService} from '../../../services/electricity.service';
import {MONTHS} from '../../../lib/DateUtil';
import {ApplicationService} from '../../../services/application.service';
import {BasePopover} from '../../../classes/BasePopover';
import {PopoverRef} from '../../../popovers/popover/popover-ref';
import * as moment from 'moment';
import {TrackAnalyticsService} from '../../../services/track-analytics.service';

@Component({
    selector: 'app-finance-details',
    templateUrl: './finance-details.component.html',
    styleUrls: ['./finance-details.component.scss'],
    viewProviders: [ApiService]
})

export class FinanceDetailsComponent extends BasePopover implements OnInit {

    refresh = [];

    finance = {
        trend: 0,
        amount: 0,
        percent: 0,
        from: null,
        to: null
    };

    config = {
        notify: 0
    };

    data_available = false;

    lotti_config = {
        path: 'assets/anim/finance-detail-2.json',
        renderer: 'svg',
        autoplay: true,
        autoplaySegments: false,
        loop: true,
        name: 'Smart Meter'
    };

    private animation = null;

    infoVisible = false;

    constructor(private _notification: ToastrService,
                private analytics: TrackAnalyticsService,
                private _apiService: ApiService,
                private _mockData: MockDataService,
                private _userService: UserService,
                private electricity: ElectricityService,
                private application: ApplicationService,
                protected popoverRef: PopoverRef) {
        super(popoverRef);
    }

    ngOnInit() {
        this.getFinanceData();
    }

    animationCreated(anim: any) {
        this.animation = anim;
    }

    getFinanceData(): void {
        const s = this.electricity.getBillPrediction().subscribe(
            (res: any) => {
                if (!res) {
                    return;
                }
                if (res.sum_of_prepayments > 12) {
                    this.data_available = true;
                    this.extractFinanceData(res);
                    s.unsubscribe();
                }
            }
        );
    }

    formatStartDate(date: Date): string {
        if (this.application.isDemoMode()) {
            const now = new Date();
            return `01.01.${now.getFullYear()}`;
        }
        return this.formatDate(date);
    }

    formatEndDate(date: Date): string {
        if (this.application.isDemoMode()) {
            const now = new Date();
            return `31.12.${now.getFullYear()}`;
        }
        return this.formatDate(date);
    }

    private formatDate(date: Date): string {
        const parsedDate = moment(date);
        return parsedDate
            .format(`DD. ** YYYY`)
            .replace('**', MONTHS[parsedDate.month()]);
    }

    private extractFinanceData(data: any): void {
        const estimated_cost = data.estimated_cost_billing_period;
        const sum_prepayments = data.sum_of_prepayments;

        const difference = estimated_cost - sum_prepayments;
        const percentage = 100 * (difference) / sum_prepayments;

        this.data_available = sum_prepayments > 12 && (percentage > -50 && percentage < 50);
        this.finance.percent = Math.round(percentage);

        if (percentage > 10 && difference > 10) {
            this.finance.amount = Math.ceil(difference / 10) * 10;
            this.finance.trend = 1;
        } else if (percentage < -10 && difference < -10) {
            this.finance.amount = Math.abs(Math.floor(difference / 10) * 10);
            this.finance.trend = -1;
        } else {
            this.finance.trend = 0;
            this.finance.amount = 0;
        }

        this.finance.from = new Date(data.billing_period_from);
        this.finance.to = new Date(data.billing_period_until);
    }

    saveNotification() {
        if (this.config.notify > 0) {
            this.config.notify = 0;

            this.analytics.trackEvent({
                action: 'push_disable',
                properties: {
                    category: 'Push',
                    label: 'type: prediction; screen: Abschlags-Check'
                }
            });

            this._notification.warning('Benachrichtigung deaktiviert!');
        } else {
            this.config.notify = 1;

            this.analytics.trackEvent({
                action: 'push_enable',
                properties: {
                    category: 'Push',
                    label: 'type: prediction; screen: Abschlags-Check'
                }
            });

            this._notification.success('Benachrichtigung aktiviert!');
        }

        /*
        TODO: Einstellungen speichern
         */
        this._notification.info('Ihre Einstellung kann noch nicht übernommen werden!');
    }

    openLink(): void {
        window.open('https://www.eon.de/de/meineon/start.html');
    }

}
